module.exports = __webpack_public_path__ + "img/member2.46e36349.jpg";